import {
  Box,
  Typography,
  Divider,
  Grid,
  Paper,
  Button,
  Stack,
  Chip,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

export default function ReviewPage({ data, onNext, onBack }) {
  const {
    roomId,
    checkin = "2025-11-12",
    checkout = "2025-11-15",
    rent = 120,
    deposit = 100,
    adults = 2,
    children = 0,
    pets = 0,
    guestName = "John Doe",
    phone = "123-456-7890",
    email = "johndoe@email.com",
    idType = "Driver License",
    idNumber = "D1234567",
    paymentStatus = "Skipped",
  } = data;

  const totalNights = 3;
  const totalAmount = rent * totalNights + deposit;

  return (
    <Box>
      <Typography variant="h5" gutterBottom>
        Review & Confirm Check-In
      </Typography>
      <Typography variant="body2" color="text.secondary" mb={3}>
        Please verify all details before confirming. You can still go back to make corrections.
      </Typography>

      {/* Summary Panel */}
      <Paper
        variant="outlined"
        sx={{ p: 3, borderRadius: 2, borderColor: "divider", mb: 4 }}
      >
        <Grid container spacing={3}>
          {/* Room & Stay Info */}
          <Grid item xs={12} md={6}>
            <Typography variant="subtitle1" fontWeight={600} gutterBottom>
              🏨 Room & Stay Details
            </Typography>
            <Typography>Room Number: <strong>{roomId}</strong></Typography>
            <Typography>Check-In: <strong>{checkin}</strong></Typography>
            <Typography>Check-Out: <strong>{checkout}</strong></Typography>
            <Typography>
              Duration: <strong>{totalNights}</strong> nights
            </Typography>
            <Typography>Rent / Night: ${rent}</Typography>
            <Typography>Deposit: ${deposit}</Typography>
            <Typography>
              Guests: {adults} Adult(s), {children} Child(ren), {pets} Pet(s)
            </Typography>
          </Grid>

          {/* Guest Info */}
          <Grid item xs={12} md={6}>
            <Typography variant="subtitle1" fontWeight={600} gutterBottom>
              👤 Guest Information
            </Typography>
            <Typography>Name: {guestName}</Typography>
            <Typography>Phone: {phone}</Typography>
            <Typography>Email: {email}</Typography>
            <Typography>ID Type: {idType}</Typography>
            <Typography>ID Number: {idNumber}</Typography>
          </Grid>
        </Grid>
      </Paper>

      {/* Payment Summary */}
      <Paper
        variant="outlined"
        sx={{
          p: 3,
          mb: 4,
          borderRadius: 2,
          backgroundColor: paymentStatus === "Skipped" ? "#fff8e1" : "#e8f5e9",
        }}
      >
        <Typography variant="subtitle1" fontWeight={600} gutterBottom>
          💳 Payment Summary
        </Typography>
        <Typography>Base Rent: ${rent * totalNights}</Typography>
        <Typography>Deposit: ${deposit}</Typography>
        <Typography variant="h6" mt={1}>
          Total: ${totalAmount}
        </Typography>

        <Stack direction="row" alignItems="center" spacing={1} mt={2}>
          <Chip
            label={
              paymentStatus === "Skipped" ? "Payment Skipped" : "Payment Received"
            }
            color={paymentStatus === "Skipped" ? "warning" : "success"}
            size="small"
          />
          <Typography variant="body2" color="text.secondary">
            {paymentStatus === "Skipped"
              ? "Payment pending for this check-in"
              : "All dues cleared"}
          </Typography>
        </Stack>
      </Paper>

      <Divider sx={{ my: 3 }} />

      {/* Action Buttons */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mt: 2,
        }}
      >
        <Button
          variant="outlined"
          startIcon={<ArrowBackIcon />}
          onClick={onBack}
        >
          Back
        </Button>

        <Button
          variant="contained"
          color="success"
          size="large"
          endIcon={<CheckCircleIcon />}
          onClick={() => onNext({ status: "checkedIn", paymentStatus })}
        >
          Confirm Check-In
        </Button>
      </Box>
    </Box>
  );
}
